var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("SummaryReport.Results.ProductivenessDescription")))
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t("SummaryReport.Results.ProductivenessDescription_Instructions")
        )
      )
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Section")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("SummaryReport.Results.MeasuredTargetsTitle")))
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t("SummaryReport.Results.MeasuredTargetsTitle_Instructions")
        )
      )
    ]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [
        _c("b", [_vm._v(_vm._s(_vm.$t("SummaryReport.Results.Meter.Change")))])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(_vm._s(_vm.$t("SummaryReport.Results.Meter.Description")))
        ])
      ])
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t("SummaryReport.Results.Meter.MeterWithIndex_Instructions")
        )
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ml-3" }, [
      _c("span", { staticClass: "mt-0" }, [
        _c("b", [
          _vm._v(
            _vm._s(_vm.$t("SummaryReport.Results.Meter.SpecifyingDetails"))
          )
        ])
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c("b", [
            _vm._v(
              _vm._s(_vm.$t("SummaryReport.Results.Meter.MeasurementMethod"))
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [
            _vm._v(_vm._s(_vm.$t("SummaryReport.Results.Meter.AskedCount")))
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("b", [
            _vm._v(_vm._s(_vm.$t("SummaryReport.Results.Meter.AnswerCount")))
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("SummaryReport.Results.PositiveFactors")))
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("SummaryReport.Results.NegativeFactors")))
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("SummaryReport.Results.TargetResultComparison")))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }